'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import type { ReactNode } from 'react'

import { AppUiVisual } from '../../app-ui-visual'
import { AVATAR_COLORS, client, CLIENT_COUNT, CLIENT_DETAILS, CLIENT_LIST } from '../../demo-data'
import { PhoneFrame } from '../../frames'
import { legalFormLabel, useVisualCopy } from '../../visual-copy'
import styles from '../mobile-visual.module.css'
import { useScenario } from '../use-scenario'
import { DetailLabel, Icon, StatusBar, TabBar } from './chrome'

const KLANTEN = CLIENT_LIST.map(({ nr, team }) => {
  const { name, form } = client(nr)
  return { nr, naam: name, tag: form, beheerders: team }
})

const linkIcon = (
  <Icon size={11} strokeWidth={1.8}>
    <path d="M14 5h5v5M19 5l-8 8M18 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
  </Icon>
)

/** A labeled data row in the klanten detail (round icon + label + value, optional trailing link). */
function DetailRow({
  icon,
  label,
  value,
  link,
  last,
}: {
  icon: ReactNode
  label: string
  value: string
  link?: boolean
  last?: boolean
}) {
  return (
    <div
      className="flex items-center gap-2.5 py-1.5"
      style={{ borderBottom: last ? 'none' : '1px solid var(--mv-hairline)' }}
    data-sentry-component="DetailRow" data-sentry-source-file="klanten-phone.tsx">
      <span
        className="flex size-6 shrink-0 items-center justify-center rounded-full"
        style={{
          background: link ? 'var(--mv-busy-bg)' : 'var(--mv-icon-bg)',
          color: link ? 'var(--mv-busy-fg)' : 'var(--mv-text2)',
        }}
      >
        {icon}
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="text-[7.5px] font-bold tracking-[0.03em]" style={{ color: 'var(--mv-text2)' }}>
          {label}
        </span>
        <span className="truncate text-[10.5px] font-medium tabular-nums">{value}</span>
      </div>
      {link && <span style={{ color: 'var(--mv-text2)' }}>{linkIcon}</span>}
    </div>
  )
}

export function KlantenPhone({ className }: { className?: string }) {
  const { t } = useVisualCopy()
  const { ref, beat } = useScenario(13, { intervalMs: 1000 })
  const step = beat ?? 8

  const detailOpen = step >= 3 && step < 12
  const selecting = step === 2

  return (
    <AppUiVisual label={t.screen.mobile.captionDossier} className={className} data-sentry-element="AppUiVisual" data-sentry-component="KlantenPhone" data-sentry-source-file="klanten-phone.tsx">
      <PhoneFrame screenClassName={clsx(styles.root, styles.phoneScreen)} data-sentry-element="PhoneFrame" data-sentry-source-file="klanten-phone.tsx">
        <div
          ref={ref}
          className={clsx(styles.root, 'relative flex h-full flex-col')}
          style={{ background: 'var(--mv-scr)', color: 'var(--mv-text)' }}
        >
          <StatusBar
            detailOpen={detailOpen}
            title={detailOpen ? t.screen.mobile.clientDetails : t.word.clients}
            subtitle={`${CLIENT_COUNT} ${t.word.clientsLower}`}
          data-sentry-element="StatusBar" data-sentry-source-file="klanten-phone.tsx" />

          <div className="relative min-h-0 flex-1 px-2 pt-0.5 pb-1.5">
            {/* Client list */}
            <div className={clsx('h-full', styles.fade)} style={{ opacity: detailOpen ? 0 : 1 }}>
              <div
                className="flex h-full flex-col justify-evenly rounded-[11px] px-2.5 py-1"
                style={{ background: 'var(--mv-card)' }}
              >
                {KLANTEN.map((kl) => (
                  <div
                    key={kl.nr}
                    className={clsx('-mx-1.5 flex items-center gap-2.5 rounded-[9px] px-1.5 py-2', styles.tone)}
                    style={{ background: selecting && kl.nr === '10002' ? 'var(--mv-accent-soft)' : 'transparent' }}
                  >
                    <div className="flex min-w-0 flex-1 flex-col gap-1">
                      <span className="truncate text-[12.5px] font-medium">{kl.naam}</span>
                      <span className="flex items-center gap-1.5">
                        <span className="shrink-0 text-[8px] tabular-nums" style={{ color: 'var(--mv-text2)' }}>
                          #{kl.nr}
                        </span>
                        <span
                          className="shrink-0 rounded-[4px] px-1 py-px text-[7.5px] font-bold tracking-[0.02em]"
                          style={{ background: 'var(--mv-accent-soft)', color: 'var(--mv-accent)' }}
                        >
                          {legalFormLabel(t, kl.tag).toUpperCase()}
                        </span>
                        <span className="flex shrink-0 items-center gap-1" style={{ color: 'var(--mv-text2)' }}>
                          <Icon size={11}>
                            <path d="M3.5 6.5a2 2 0 0 1 2-2h3l2 2.5h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2Z" />
                          </Icon>
                          <span className="text-[7.5px] font-semibold tracking-[0.01em]">
                            2 {t.screen.mobile.projects}
                          </span>
                        </span>
                      </span>
                    </div>
                    <span className="flex shrink-0 items-center">
                      {kl.beheerders.map((ini, i) => (
                        <span
                          key={ini + i}
                          className="flex size-[22px] items-center justify-center rounded-full text-[7.5px] font-bold text-white"
                          style={{
                            background: AVATAR_COLORS[ini],
                            border: '2px solid var(--mv-card)',
                            marginLeft: i === 0 ? 0 : -5,
                          }}
                        >
                          {ini}
                        </span>
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Client detail: slides in */}
            <div
              className={clsx(
                'absolute inset-0 flex flex-col gap-1.5 overflow-hidden rounded-[14px] px-2 py-0.5',
                styles.slideX,
              )}
              style={{
                background: 'var(--mv-scr)',
                opacity: detailOpen ? 1 : 0,
                transform: detailOpen ? 'translateX(0)' : 'translateX(18px)',
                pointerEvents: 'none',
              }}
            >
              <div
                className="flex items-center gap-2.5 rounded-[12px] px-3 py-2.5"
                style={{ background: 'var(--mv-card)' }}
              >
                <span
                  className="flex size-6 shrink-0 items-center justify-center rounded-[8px]"
                  style={{ background: 'var(--mv-icon-bg)', color: 'var(--mv-text2)' }}
                >
                  <Icon size={13} data-sentry-element="Icon" data-sentry-source-file="klanten-phone.tsx">
                    <rect x="3.5" y="7.5" width="17" height="12" rx="2.5" data-sentry-element="rect" data-sentry-source-file="klanten-phone.tsx" />
                    <path d="M8.5 7.5V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.5M3.5 12.5h17" data-sentry-element="path" data-sentry-source-file="klanten-phone.tsx" />
                  </Icon>
                </span>
                <div className="flex min-w-0 flex-col gap-0.5">
                  <span className="truncate text-[12px] font-medium">{client('10002').name}</span>
                  <span className="flex items-center gap-1.5">
                    <span className="text-[8.5px] tabular-nums" style={{ color: 'var(--mv-text2)' }}>
                      #{client('10002').nr}
                    </span>
                    <span
                      className="rounded-[5px] px-1.5 py-px text-[7px] font-bold"
                      style={{ background: 'var(--mv-busy-bg)', color: 'var(--mv-busy-fg)' }}
                    >
                      {client('10002').form}
                    </span>
                  </span>
                </div>
              </div>

              <DetailLabel data-sentry-element="DetailLabel" data-sentry-source-file="klanten-phone.tsx">{t.screen.clientRecord.accountManager}</DetailLabel>
              <div
                className="flex items-center gap-2.5 rounded-[12px] px-3 py-2.5"
                style={{ background: 'var(--mv-card)' }}
              >
                <span
                  className="flex size-6 shrink-0 items-center justify-center rounded-full text-[8px] font-bold text-white"
                  style={{ background: AVATAR_COLORS.AS }}
                >
                  AS
                </span>
                <div className="flex flex-col">
                  <span className="text-[7px] font-bold tracking-[0.03em]" style={{ color: 'var(--mv-text2)' }}>
                    {t.word.name.toUpperCase()}
                  </span>
                  <span className="text-[11px] font-medium">Anouk Smit</span>
                </div>
              </div>

              <DetailLabel data-sentry-element="DetailLabel" data-sentry-source-file="klanten-phone.tsx">{t.screen.mobile.contact}</DetailLabel>
              <div className="flex flex-col rounded-[12px] px-2.5" style={{ background: 'var(--mv-card)' }}>
                <DetailRow
                  link
                  icon={
                    <Icon size={12}>
                      <circle cx="12" cy="12" r="8.5" />
                      <path d="M3.5 12h17M12 3.5c2.5 2.4 2.5 14.6 0 17M12 3.5c-2.5 2.4-2.5 14.6 0 17" />
                    </Icon>
                  }
                  label={t.screen.mobile.website}
                  value="www.vandijkvastgoed.nl"
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
                <DetailRow
                  link
                  icon={
                    <Icon size={12}>
                      <rect x="3.5" y="5.5" width="17" height="13" rx="2.5" />
                      <path d="m4 7 8 6 8-6" />
                    </Icon>
                  }
                  label={t.screen.mobile.email}
                  value="info@vandijkvastgoed.nl"
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
                <DetailRow
                  link
                  last
                  icon={
                    <Icon size={12}>
                      <path d="M6.5 4h3l1.5 4-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2 4 1.5v3a1.5 1.5 0 0 1-1.5 1.5A15.5 15.5 0 0 1 5 5.5 1.5 1.5 0 0 1 6.5 4Z" />
                    </Icon>
                  }
                  label={t.screen.mobile.phone}
                  value="+31 30 7952517"
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
              </div>

              <DetailLabel data-sentry-element="DetailLabel" data-sentry-source-file="klanten-phone.tsx">{t.screen.mobile.companyDetails}</DetailLabel>
              <div className="flex flex-col rounded-[12px] px-2.5" style={{ background: 'var(--mv-card)' }}>
                <DetailRow
                  icon={
                    <Icon size={12}>
                      <path d="M5 9h14M4.5 15h14M9.5 4 8 20M16 4l-1.5 16" />
                    </Icon>
                  }
                  label={t.screen.mobile.debtorNumber}
                  value={client('10002').nr}
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
                <DetailRow
                  icon={
                    <Icon size={12}>
                      <rect x="3.5" y="7.5" width="17" height="12" rx="2.5" />
                      <path d="M8.5 7.5V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.5M3.5 12.5h17" />
                    </Icon>
                  }
                  label={t.screen.mobile.kvk}
                  value={CLIENT_DETAILS['10002'].kvk}
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
                <DetailRow
                  icon={
                    <Icon size={12}>
                      <path d="M6 3.5h7L18 8.5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Z" />
                      <path d="M13 3.5V9h5" />
                    </Icon>
                  }
                  label={t.screen.mobile.vatNumber}
                  value={CLIENT_DETAILS['10002'].btw}
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
                <DetailRow
                  last
                  icon={
                    <Icon size={12}>
                      <rect x="3" y="5.5" width="18" height="13" rx="2.5" />
                      <path d="M3 9.5h18" />
                    </Icon>
                  }
                  label={t.screen.mobile.accountNumber}
                  value={CLIENT_DETAILS['10002'].iban}
                data-sentry-element="DetailRow" data-sentry-source-file="klanten-phone.tsx" />
              </div>
            </div>
          </div>

          <TabBar activeIndex={4} data-sentry-element="TabBar" data-sentry-source-file="klanten-phone.tsx" />
        </div>
      </PhoneFrame>
    </AppUiVisual>
  )
}

/** Section label above a card group in the klanten detail. */
